import { render, staticRenderFns } from "./modal_excluir_item_comanda_auditoria.vue?vue&type=template&id=120ffff3&scoped=true&"
import script from "./modal_excluir_item_comanda_auditoria.vue?vue&type=script&lang=js&"
export * from "./modal_excluir_item_comanda_auditoria.vue?vue&type=script&lang=js&"
import style0 from "./modal_excluir_item_comanda_auditoria.vue?vue&type=style&index=0&id=120ffff3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120ffff3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VDivider,VIcon,VSpacer,VToolbar,VToolbarTitle})
